import type { ReactNode } from "react";
import type { DataElScope } from "@/utils/dataEl";
import { useSessionMemberGlimpseBridge } from "@/contexts/session/ui/use-session-member-glimpse-bridge";
import { Ctooltip } from "../Ctooltip";

const ALREADY_FOCUSED_HINT_TEXT = "Already focused";
const ALREADY_FOCUSED_HINT_DURATION_MS = 2000;

export interface CreferenceInteractionOverlaysProps {
  dataElScope: DataElScope;
  hintAnchorElement: HTMLSpanElement | null;
  isAlreadyFocusedHintVisible: boolean;
  isMemberGlimpseVisible: boolean;
  memberId: string | null;
  onAlreadyFocusedHintDismiss: () => void;
  onMemberGlimpseClose: () => void;
}

export function CreferenceInteractionOverlays({
  dataElScope,
  hintAnchorElement,
  isAlreadyFocusedHintVisible,
  isMemberGlimpseVisible,
  memberId,
  onAlreadyFocusedHintDismiss,
  onMemberGlimpseClose,
}: CreferenceInteractionOverlaysProps): ReactNode {
  // Glimpses render through the single session-level host, not a local mount.
  useSessionMemberGlimpseBridge({
    memberId: isMemberGlimpseVisible ? memberId : null,
    onClose: onMemberGlimpseClose,
  });
  return (
    <>
      <Ctooltip
        dataElScope={dataElScope}
        visible={isAlreadyFocusedHintVisible}
        anchorElement={hintAnchorElement}
        title={ALREADY_FOCUSED_HINT_TEXT}
        onDismiss={onAlreadyFocusedHintDismiss}
        autoDismissMs={ALREADY_FOCUSED_HINT_DURATION_MS}
      />
    </>
  );
}
